import styled from 'styled-components';

export const RadiosContainer = styled.div`
  display: -webkit-box;
  flex-direction: column;
  justify-content: space-between;
  max-width: 1200px;
`;
export const ChangeSelectedWrapper = styled.div`
  display: -webkit-box;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 0;
  width: min-content;
  max-width: 1200px;
  margin-bottom: 10px;
`;
export const TeamsContainer = styled.div`
  display: inline-flex;
  min-width: 200px;
  align-items: center;
  span {
    font-family: 'Proxima Nova' !important;
    font-size: 16px !important;
    letter-spacing: 0.16px;
    font-weight: 400 !important;
  }
`;
export const CheckBoxText = styled.span`
  color: var(--DarkGray);
  width: max-content;
  font-weight: 500;
  font-size: 16px;
  display: -webkit-box;

  padding: 2px 0;
`;
export const UnselectedText = styled.span`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 12px;
  min-width: max-content;
  display: block;
`;

export const ChangeSponsorOptions = styled.div`
  display: flex;
  justify-content: center;
  & > div {
    margin-left: 10px;
  }
  & > div:last-of-type {
    margin-right: 10px;
  }
`;
export const CheckBoxWrapper = styled.div``;
export const CheckBoxContainer = styled.div`
  width: max-content;
  border: 1px solid rgba(240, 240, 240, 1);
  border-radius: 8px;
  background: linear-gradient(0deg, rgba(250, 250, 250, 0.99) 0%, rgba(255, 255, 255, 0.99) 100%);
  display: inline-flex;
  justify-content: space-around;
  align-items: center;
  padding: 0px 10px 0px 10px;
  min-height: 43px;
  margin-right: 10px;
`;
